<template>
    <div class="compliance-badge"
         :class="testClass">
        <b-badge :variant="badgeVariant" class="m-1">
            {{ statusLabel }}
        </b-badge>
        <b-badge variant="success" class="m-1"
                 v-if="compliance.has_exemption">
            Exempt
        </b-badge>
    </div>
</template>

<script>
export default {
    name: 'ComplianceBadge',
    props: {
        compliance: Object
    },
    computed: {
        statusLabel () {
            const status = this.compliance.status
            if (status === 'NA') {
                return 'N/A'
            } else if (status === 'NONCOVERED') {
                return 'Non-Covered'
            } else if (status === 'COMPLIANT') {
                return 'Compliant'
            } else if (status === 'NONCOMPLIANT') {
                return 'Noncompliant'
            } else {
                return '-'
            }
        },
        badgeVariant () {
            const status = this.compliance.status
            if (status === 'NA') {
                return 'warning'
            } else if (status === 'NONCOVERED') {
                return 'success'
            } else if (status === 'COMPLIANT') {
                return 'success'
            } else if (status === 'NONCOMPLIANT') {
                return 'danger'
            } else {
                return 'default'
            }
        },
        testClass () {
            return `t-${this.compliance.effective}`
        }
    }
}
</script>

<style lang="scss">
.compliance-badge {
    display: inline-block;
}
</style>
